(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/x-pseudo", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/x-pseudo"] = factory();
	else
		root["i18n/x-pseudo"] = factory();
})(window, function() {
return 